import * as React from "react";
import { forwardRef } from "react";
const SvgInbox = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M65.232 39.7c-.163-2.386-2.098-4.54-4.843-4.542h-5.541V7h-9.696v28.158h-5.54c-3.994.001-6.273 4.56-3.878 7.756l10.389 13.852c1.94 2.584 5.817 2.584 7.756 0l10.389-13.852a4.77 4.77 0 0 0 .964-3.215" />
    <path d="M27 23.904a4 4 0 0 0-3.58 2.215l-15 30.096A4 4 0 0 0 12 62h21l4.8 6.4A4 4 0 0 0 41 70h18a4 4 0 0 0 3.2-1.6L67 62h21a4 4 0 0 0 3.58-5.785l-15-30.096A4 4 0 0 0 73 23.904h-8a4 4 0 0 0-4 4 4 4 0 0 0 4 4h5.523L81.537 54H65a4 4 0 0 0-3.2 1.6L57 62H43l-4.8-6.4A4 4 0 0 0 35 54H18.463l11.014-22.096H35a4 4 0 0 0 4-4 4 4 0 0 0-4-4z" />
    <path d="M8 65v20a4 4 0 0 0 4 4h76a4 4 0 0 0 4-4V65h-8v16H16V65Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgInbox);
export default ForwardRef;
